import { CheckItem, Entry } from '@app/models/_index';

import { FilterMatchType } from '@app/enums/_index';

/**
 * Filter Catalog Item used by the catalog to filter by match type
 * Extends base Entry item
 */
export class FilterCategoryItem extends Entry<CheckItem> {
  constructor(
    public id: string,
    public title: string,
    public body: string,
    public array: Array<CheckItem>,
    public isExpanded: boolean,
    public match: FilterMatchType
  ) {
    super(title, body, array, isExpanded, match);
  }
}
